// Clean and normalize input value
export const normalizeNameInput = input => {
    return input.replace(/\s{2,}|[^A-Za-z\s]/g, '');
};

export const capitalizeCredentials = input => {
    return input.replace(
        /\b\w+/g,
        char => char.charAt(0).toUpperCase() + char.slice(1).toLowerCase()
    );
};

export const cleanValue = (name, value) => {
    if (name === 'email' || name === 'password') {
        return value.trim();
    } else if (name === 'name' || name === 'lastName') {
        return capitalizeCredentials(normalizeNameInput(value));
    } else {
        return value;
    }
};